import { Text } from '@nimbus-ds/components';
import { InteractiveList } from '@nimbus-ds/patterns';
import { CategoryTabedResponseDto } from '@tiendanube/common';

interface CategoryCheckboxItemProps {
  category: CategoryTabedResponseDto;
  checked: boolean;
  onChange: () => void;
}

function CategoryCheckboxItem({
  category,
  checked,
  onChange,
}: Readonly<CategoryCheckboxItemProps>): JSX.Element {
  const fullPath = category.fixed
    ? `${category.fixed.prefix}${category.fixed.title}`
    : category.title;

  const pathParts = fullPath.split('/');

  const renderTitle = () => {
    if (pathParts.length === 1) {
      return <Text fontWeight="bold">{pathParts[0]}</Text>;
    }

    const allButLast = pathParts.slice(0, -1).join('/');
    const lastItem = pathParts.at(-1);

    return (
      <Text>
        {allButLast}/
        <Text as="span" fontWeight="bold">
          {lastItem}
        </Text>
      </Text>
    );
  };

  return (
    <InteractiveList.CheckboxItem
      title=""
      showTitle={false}
      checkbox={{
        name: category.id,
        checked,
        onChange,
      }}
    >
      {renderTitle()}
    </InteractiveList.CheckboxItem>
  );
}

export default CategoryCheckboxItem;
